import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/crop-target`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getPreviousCropTargetData: () => `${RESOURCE_ENDPOINT}/get-previous-crop-target-data`,
    getTargetDataForProduction: () => `${RESOURCE_ENDPOINT}/get-target-data-for-production`,
    getTargetBlockData: () => `${RESOURCE_ENDPOINT}/get-target-block-data`,
    progressData: () => `${RESOURCE_ENDPOINT}/progress-data`,
    checkTargetExistence: () => `${RESOURCE_ENDPOINT}/check-target-existence`,
}

export default class CropTargetApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any, params = {}): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url, params);
    }

    public create = (payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public getPreviousCropTargetData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPreviousCropTargetData();
        return HttpService.get(url, params, headers);
    }

    public getTargetDataForProduction = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTargetDataForProduction();
        return HttpService.get(url, params, headers);
    }

    public getTargetBlockData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTargetBlockData();
        return HttpService.post(url, payload, params, headers);
    }

    public progressData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.progressData();
        return HttpService.get(url, params, headers);
    }

    public checkTargetExistence = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.checkTargetExistence();
        return HttpService.get(url, params, headers);
    }
}
